import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss']
})
export class ConfirmDialogComponent implements OnInit {
  mensaje: string = '';
  titulo: string = '';
  buttons: string[];

  constructor(
    public dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.mensaje = data.mensaje;
      this.titulo = data.titulo;
      this.buttons = data.buttons;
  }

  ngOnInit(): void {
    
  }

  cancel(): void{
    this.dialogRef.close(false);
  }

  confirm(): void{
    this.dialogRef.close(true);
  }
}
